import { Navigate, Outlet } from 'react-router';

import { useSession } from '@/components/auth/user-provider';
import { useStaffSession } from '@/components/auth/staff-session-provider';

/**
 * Route guard for staff workspace routes.
 * Redirects to the public site when:
 * - The user is not signed in (handled by AppShell separately).
 * - The effective staff role is `community` or null (non-staff).
 *
 * This ensures a staff user acting as "Community member" cannot access
 * the workspace UI, matching the server-side enforcement.
 */
export function RequireStaff() {
  const { session } = useSession();
  const { staffRole, loading } = useStaffSession();

  if (session.status === 'loading' || loading) {
    return null;
  }

  if (session.status !== 'signedIn') {
    return <Navigate to="/" replace />;
  }

  if (staffRole !== 'staff' && staffRole !== 'admin' && staffRole !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
